import(/* webpackMode: "eager", webpackExports: ["Canvas"] */ "/vercel/path0/app/components/canvas/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/me/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/page.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\",\"cyrillic\"]}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/page.module.css");
